/*
 * Public API Surface of prasad-angular
 */

export * from './lib/prasad-angular.service';
export * from './lib/prasad-angular.component';
export * from './lib/prasad-angular.module';
